import { render } from "./ModalConfirmDelete.vue?vue&type=template&id=26087cbc&scoped=true"
import script from "./ModalConfirmDelete.vue?vue&type=script&lang=js"
export * from "./ModalConfirmDelete.vue?vue&type=script&lang=js"

import "./ModalConfirmDelete.vue?vue&type=style&index=0&id=26087cbc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26087cbc"]])

export default __exports__